module.exports = __webpack_public_path__ + "media/images/frontend/covid19-full-d4972ac02616bc36baa75ff0a3430c69.png";